import { env } from '@/env';
import type { MemberUserAvatarBodyDto, MemberUserAvatarResponse } from '@/models/interface/member';
import { ApiFactory } from '@/utils/api';
import type { AxiosResponse } from 'axios';

const baseUrl: string = env.apiBaseUrlNoVersion;

export class MemberV2Service extends ApiFactory {
  constructor() {
    super(baseUrl);
  }

  /**
   * 修改 會員大頭貼
   * @param body - 會員大頭貼的請求資料 (圖檔，FormData 格式)
   * @param options - API 請求選項
   *
   * @remarks
   * - 回傳大頭貼的 URL
   */
  modifyMemberAvatar(body: MemberUserAvatarBodyDto): Promise<MemberUserAvatarResponse> {
    return super.put('v2/Member/avatar', body);
  }

  /**
   * 取得會員合約書 PDF
   */
  getContractPdf(): Promise<AxiosResponse<Blob>> {
    return super.get<void, AxiosResponse<Blob>>('v2/Member/GetContractPdf', undefined, {
      responseType: 'blob',
      headers: {
        'X-Silent-Error': 'true'
      }
    });
  }
}
